export default __webpack_public_path__ + "static/media/cif-ws.624ad312.svg";